import gql from "graphql-tag";

export const DELETE_POST = gql`
  mutation deletePost($postId: String!, $enable: Boolean) {
    deletePost(postId: $postId, enable: $enable)
  }
`;
